import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants/shared';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import { RequiredPayloadFieldIsNotProvided } from '@savgroup-front-common/exceptions/client/errors/RequiredPayloadFieldIsNotProvided';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.payment}invoices/${COMMON_QUERY_PARAMS.INVOICE_ID}/confirmPayment`;

interface ConfirmPaymentIntentCommandPayload {
  invoiceId: string;
  metadata?: {
    sessionResult: string;
  };
}

async function confirmPaymentIntent({
  invoiceId,
  metadata,
}: ConfirmPaymentIntentCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> {
  const functionName = 'confirmPaymentIntent';

  if (!invoiceId) {
    throw new RequiredPayloadFieldIsNotProvided(invoiceId, functionName);
  }

  const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.INVOICE_ID, invoiceId);

  try {
    return await apiCall(url, {
      method: SUPPORTED_METHODS.POST,
      json: {
        metadata,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default confirmPaymentIntent;
